class UserRole {
    constructor({ id, name, type, description }) {
        this.roleId = id
        this.roleName = name
        this.roleType = type
        this.roleDescription = description
    }
}

export default UserRole